import React from 'react';
import { motion } from 'framer-motion';
import { Clock, AlertTriangle, CheckCircle2, Crown, Sparkles } from 'lucide-react';
import { Section } from './ui/Section';
import { Button } from './ui/Button';
export const PricingSection = () => {
  return <Section background="white" id="comprar" data-id="element-213">
      {/* Launch Price Warning */}
      <div className="max-w-3xl mx-auto text-center mb-16" data-id="element-214">
        <div className="inline-flex items-center gap-2 bg-red-100 text-red-700 px-4 py-2 rounded-full font-bold text-sm mb-6" data-id="element-215">
          <Clock className="w-4 h-4" data-id="element-216" />
          PRECIO DE LANZAMIENTO — CIERRA EN:
        </div>

        {/* Static Countdown */}
        <div className="flex justify-center gap-4 mb-6" data-id="element-217">
          <div className="flex flex-col items-center" data-id="element-218">
            <div className="bg-stone-900 text-white text-4xl md:text-5xl font-extrabold rounded-xl w-20 h-20 md:w-24 md:h-24 flex items-center justify-center shadow-lg font-heading" data-id="element-219">
              23
            </div>
            <span className="text-xs font-bold text-stone-500 uppercase mt-2 tracking-wider" data-id="element-220">
              Horas
            </span>
          </div>
          <div className="text-4xl md:text-5xl font-extrabold text-stone-300 mt-4" data-id="element-221">
            :
          </div>
          <div className="flex flex-col items-center" data-id="element-222">
            <div className="bg-stone-900 text-white text-4xl md:text-5xl font-extrabold rounded-xl w-20 h-20 md:w-24 md:h-24 flex items-center justify-center shadow-lg font-heading" data-id="element-223">
              59
            </div>
            <span className="text-xs font-bold text-stone-500 uppercase mt-2 tracking-wider" data-id="element-224">
              Min
            </span>
          </div>
          <div className="text-4xl md:text-5xl font-extrabold text-stone-300 mt-4" data-id="element-225">
            :
          </div>
          <div className="flex flex-col items-center" data-id="element-226">
            <div className="bg-stone-900 text-white text-4xl md:text-5xl font-extrabold rounded-xl w-20 h-20 md:w-24 md:h-24 flex items-center justify-center shadow-lg font-heading" data-id="element-227">
              47
            </div>
            <span className="text-xs font-bold text-stone-500 uppercase mt-2 tracking-wider" data-id="element-228">
              Seg
            </span>
          </div>
        </div>

        <p className="flex items-center justify-center gap-2 text-stone-600 font-medium mb-8" data-id="element-229">
          <AlertTriangle className="w-5 h-5 text-amber-500" data-id="element-230" />
          ⚠️ Después sube $400 UYU. No vuelve al precio de lanzamiento.
        </p>

        {/* Static Progress Bar */}
        <div className="max-w-md mx-auto bg-stone-50 p-4 rounded-xl border border-stone-200" data-id="element-231">
          <div className="flex justify-between text-sm font-bold text-stone-700 mb-2" data-id="element-232">
            <span className="text-red-600 flex items-center gap-1" data-id="element-233">
              🔴 Cupos al precio de lanzamiento
            </span>
            <span data-id="element-234">Quedan pocos</span>
          </div>
          <div className="w-full bg-stone-200 rounded-full h-3 mb-2 overflow-hidden" data-id="element-235">
            <motion.div initial={{
            width: 0
          }} whileInView={{
            width: '68%'
          }} viewport={{
            once: true
          }} transition={{
            duration: 1,
            ease: 'easeOut'
          }} className="bg-red-500 h-3 rounded-full" data-id="element-236"></motion.div>
          </div>
          <div className="text-xs text-stone-500 text-right font-medium" data-id="element-237">
            68% de los cupos ya tomados
          </div>
        </div>
      </div>

      <div className="text-center mb-10" data-id="element-238">
        <h2 className="text-3xl md:text-4xl font-extrabold text-stone-900" data-id="element-239">
          ELEGÍ TU KIT
        </h2>
      </div>

      {/* Pricing Cards */}
      <div className="grid md:grid-cols-3 gap-6 lg:gap-8 max-w-6xl mx-auto items-stretch md:mt-6" data-id="element-240">
        {/* Offer 1: 6 Tomos */}
        <div className="bg-white rounded-3xl p-8 border-2 border-stone-200 shadow-sm flex flex-col h-full" data-id="element-241">
          <div className="text-celeste-600 text-xl mb-4" data-id="element-242">📘</div>
          <h3 className="text-2xl font-extrabold text-stone-900 mb-2" data-id="element-243">
            Kit Aula de Éxitos
          </h3>
          <p className="text-stone-600 font-medium mb-3" data-id="element-244">
            6 Tomos · Todo el año resuelto
          </p>
          <p className="text-sm font-bold text-celeste-700 mb-6" data-id="element-245">
            Lengua Española · Matemática · Ciencias Biológicas
          </p>

          <div className="bg-stone-50 p-4 rounded-xl mb-6" data-id="element-246">
            <p className="text-sm text-stone-700 font-medium" data-id="element-247">
              <span className="font-bold block mb-1" data-id="element-248">Ideal para:</span>
              La maestra del Tramo 2 que quiere llegar al lunes con todo listo,
              sin perder el fin de semana
            </p>
          </div>

          <div className="mb-8 mt-auto" data-id="element-249">
            <div className="text-stone-400 line-through font-medium mb-1" data-id="element-250">
              Precio regular: $990 UYU
            </div>
            <div className="flex items-baseline gap-2" data-id="element-251">
              <span className="text-5xl font-extrabold text-stone-900" data-id="element-252">
                $490
              </span>
              <span className="text-xl font-bold text-stone-500" data-id="element-253">UYU</span>
            </div>
            <div className="text-sm text-emerald-600 font-bold mt-2" data-id="element-254">
              Precio de lanzamiento
            </div>
          </div>

          <Button href="https://tufenixdigital.store/cart/53832899985772:1" variant="secondary" size="lg" fullWidth data-id="element-255">
            QUIERO MI KIT AHORA!
          </Button>
        </div>

        {/* Offer 2: 6 Tomos + 6 Bonos (featured) */}
        <div className="bg-white rounded-3xl p-8 pt-10 border-2 border-emerald-500 shadow-xl shadow-emerald-900/10 flex flex-col h-full relative md:-translate-y-3" data-id="element-256">
          <div className="absolute top-0 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-emerald-500 text-white px-4 py-1.5 rounded-full text-xs sm:text-sm font-bold tracking-wide uppercase shadow-sm whitespace-nowrap" data-id="element-257">
            Recomendado
          </div>
          <div className="text-amber-500 text-xl mb-4" data-id="element-258">🎁</div>
          <h3 className="text-2xl font-extrabold text-stone-900 mb-2" data-id="element-259">
            Kit Aula de Éxitos + 6 BONOS
          </h3>
          <p className="text-stone-600 font-medium mb-3" data-id="element-260">
            6 Tomos + 6 Bonos · Todo el año resuelto
          </p>
          <p className="text-sm font-bold text-emerald-700 mb-6" data-id="element-261">
            Lengua Española · Matemática · Ciencias Biológicas
          </p>

          <div className="bg-emerald-50 p-4 rounded-xl mb-6" data-id="element-262">
            <p className="text-sm text-stone-700 font-medium" data-id="element-263">
              <span className="font-bold block mb-1" data-id="element-264">Ideal para:</span>
              La maestra que quiere el sistema completo: planificaciones,
              fichas, evaluaciones y los 6 bonos estratégicos
            </p>
          </div>

          <div className="mb-8 mt-auto" data-id="element-265">
            <div className="text-stone-400 line-through font-medium mb-1" data-id="element-266">
              Precio regular: $1490 UYU
            </div>
            <div className="flex items-baseline gap-2" data-id="element-267">
              <span className="text-5xl font-extrabold text-stone-900" data-id="element-268">
                $790
              </span>
              <span className="text-xl font-bold text-stone-500" data-id="element-269">UYU</span>
            </div>
            <div className="text-sm text-emerald-600 font-bold mt-2" data-id="element-270">
              Precio de lanzamiento
            </div>
          </div>

          <Button href="https://tufenixdigital.store/cart/53889590722924:1" variant="primary" size="lg" fullWidth data-id="element-271">
            QUIERO MI KIT + BONOS AHORA!
          </Button>
        </div>

        {/* Offer 3: PREMIUM COMPLETO */}
        <div className="bg-stone-900 rounded-3xl p-8 pt-10 border-2 border-amber-400 shadow-2xl shadow-amber-900/30 flex flex-col h-full relative md:-translate-y-3" data-id="element-272">
          <div className="absolute top-0 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-amber-400 text-stone-900 px-4 py-1.5 rounded-full text-xs sm:text-sm font-extrabold tracking-wide uppercase shadow-lg flex items-center gap-1.5 whitespace-nowrap" data-id="element-273">
            <Crown className="w-4 h-4" data-id="element-274" /> El más completo
          </div>

          <div className="flex flex-col h-full" data-id="element-275">
            <div className="text-amber-400 mb-4 flex items-center gap-1" data-id="element-276">
              <Sparkles className="w-6 h-6" data-id="element-277" />
            </div>
            <h3 className="text-2xl font-extrabold text-white mb-2" data-id="element-278">
              Kit Aula de Éxitos + COMPLETO
            </h3>
            <p className="text-amber-300 font-bold mb-3" data-id="element-279">
              TODO el Tramo 2 · Todas las áreas · TODO EL AÑO RESUELTO
            </p>
            <p className="text-sm font-semibold text-stone-300 mb-6" data-id="element-280">
              Física y Química · Ciencias de la Tierra · Historia · Geografía ·
              Ciudadanía · Lengua Española · Matemática · Ciencias Biológicas
            </p>

            <ul className="space-y-2 mb-6" data-id="element-281">
              <li className="flex items-start gap-2 text-sm text-stone-200" data-id="element-282">
                <CheckCircle2 className="w-4 h-4 text-amber-400 shrink-0 mt-0.5" data-id="element-283" />
                <span data-id="element-284">
                  <span className="font-bold text-white" data-id="element-285">12 Tomos</span> — todas
                  las áreas curriculares del Tramo 2
                </span>
              </li>
              <li className="flex items-start gap-2 text-sm text-stone-200" data-id="element-286">
                <CheckCircle2 className="w-4 h-4 text-amber-400 shrink-0 mt-0.5" data-id="element-287" />
                <span data-id="element-288">
                  <span className="font-bold text-white" data-id="element-289">12 Bonos</span>{' '}
                  estratégicos para todo el año
                </span>
              </li>
              <li className="flex items-start gap-2 text-sm text-stone-200" data-id="element-290">
                <CheckCircle2 className="w-4 h-4 text-amber-400 shrink-0 mt-0.5" data-id="element-291" />
                <span data-id="element-292">
                  <span className="font-bold text-white" data-id="element-293">1 Tomo EXCLUSIVO</span>{' '}
                  que no encontrás en ningún otro lado
                </span>
              </li>
            </ul>

            <div className="bg-stone-800 p-4 rounded-xl mb-6 border border-stone-700" data-id="element-294">
              <p className="text-sm text-stone-300 font-medium" data-id="element-295">
                <span className="font-bold text-amber-300 block mb-1" data-id="element-296">
                  Ideal para:
                </span>
                La maestra que no quiere que le falte NADA: el sistema
                definitivo, completo y para siempre. La mejor inversión por
                alumno del año.
              </p>
            </div>

            <div className="mb-8 mt-auto" data-id="element-297">
              <div className="text-stone-500 line-through font-medium mb-1" data-id="element-298">
                Precio regular: $2990 UYU
              </div>
              <div className="flex items-baseline gap-2" data-id="element-299">
                <span className="text-5xl font-extrabold text-amber-400" data-id="element-300">
                  $1490
                </span>
                <span className="text-xl font-bold text-stone-400" data-id="element-301">UYU</span>
              </div>
              <div className="text-sm text-amber-300 font-bold mt-2" data-id="element-302">
                Precio de lanzamiento — Solo por tiempo limitado
              </div>
            </div>

            <Button href="https://tufenixdigital.store/cart/53939663012204:1" size="lg" fullWidth className="bg-amber-400 text-stone-900 hover:bg-amber-300 focus:ring-amber-400" data-id="element-303">
              QUIERO EL KIT COMPLETO AHORA!
            </Button>
          </div>
        </div>
      </div>
    </Section>;
};